import { GlobalProvider, useGlobal } from "../contexts/GlobalContext";
import Button from "./Button";
import Wa from '../assets/svg/wa.svg?react'

function OurHome() {
  const { t, i18n, iUrl, parse, directusGlobals } = useGlobal();
  return (
    <section className="our-home lg:py-16">
      <div className="our-home__container flex flex-col-reverse lg:flex-col lg:grid lg:grid-cols-2 lg:max-w-content lg:mx-auto lg:px-8 lg:gap-12 lg:items-center">
        {/* Left - Text Content (inverted order) */}
        <div className="our-home__content py-16 space-y-6 px-8 lg:px-0">
          <h3 className="font-medium our-home__title font-header text-4xl lg:text-5xl text-primary-900 mb-12">
            {t("sections_data.6.section_heading")}
          </h3>

          {/* Address */}
          <div className="our-home__address space-y-2 font-body text-lg text-dark-700 [&_h3]:text-primary-700 [&_h3]:text-base [&_h3]:uppercase [&_h3]:tracking-wide [&_h3]:font-medium [&_p]:mb-8">
              { parse(t("sections_data.6.section_body")) }
          </div>

          <Button
            href={`https://wa.me/${directusGlobals.contact_whatsapp_number}`}
            color="primary"
            size="medium"
            data-umami-event="Contact Button - Whatsapp"
            data-umami-event-name="Our home">
            {t("sections_data.6.section_cta")}
            <Wa className="ml-2 h-5 w-5 fill-current" />
          </Button>
        </div>

        {/* Right - Image (inverted order) */}
        <div className="our-home__image-wrapper w-full">
          <img
            src={`${iUrl}${t("sections_data.6.section_cover")}?format=webp`}
            alt="Venice Venezia old city aerial ceramics"
            className="our-home__image w-full h-[500px] object-cover  shadow-lg"
          />
        </div>
      </div>
    </section>
  )
}

export default OurHome
